import { Toast } from '../../../../components/Common/Toast';
import { callAPI } from '../../../../services/api.service';
import { StoryAgeTitleEnum } from '../../../../interfaces/book.interface';

export interface AgeConfigModel {
  pages_total: string;
  words_total: string;
  max_text_length?: string;
  rows_total?: string;
}

export interface StoryConfigAdminModel {
  id: string;
  [ageKey: string]: AgeConfigModel | string;
}

/** Readable labels for each age-group key — sourced from StoryAgeTitleEnum (single source of truth). */
export const AGE_GROUP_LABELS: Record<string, string> = { ...StoryAgeTitleEnum };

/** Display order. */
export const AGE_GROUP_ORDER = ['0-2-year', '3-7-year', '8-12-year', 'adult'];

export const getAdminStoryConfig = async (): Promise<StoryConfigAdminModel | null> => {
  try {
    const response = await callAPI('admin/story-config', null, 'GET');
    if (response?.data?.[0]) {
      return response.data[0] as StoryConfigAdminModel;
    }
    Toast('Failed to get story configuration', true);
    return null;
  } catch (error) {
    Toast('Failed to get story configuration', true);
    return null;
  }
};

export const updateAdminStoryConfig = async (
  docId: string,
  ageKey: string,
  ageData: AgeConfigModel,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    const response = await callAPI('admin/story-config/update', {
      docId,
      ageKey,
      ...ageData,
    });
    if (response?.status === 200) {
      Toast('Reading level updated successfully');
      onSuccess?.();
      return true;
    }
    Toast(response?.message || 'Failed to update reading level', true);
    return false;
  } catch (error) {
    Toast('Failed to update reading level', true);
    return false;
  }
};
